import { getUserDataAsString } from "@/utils/user/user-data";
import { isLocalhost } from "@/utils/debug/is-dev";

export const callSlackWebhook = async (channel = "#denticalc-feedback", text = "", withUserData = false) => {
    try {
        if (isLocalhost) return;
        const url = 'https://hooks.slack.com/services/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';
        const iconUrl = 'https://public.app.denticalc.com/images/dc_4in1_150_150_transparent.png';
        const username = 'DentiCalc App Bot';

        const body = JSON.stringify({
            username: username,
            icon_url: iconUrl,
            channel: channel,
            text: withUserData ? `${text}\n\n${getUserDataAsString()}` : text,
        });

        const payload = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body,
        };

        await fetch(url, payload);
    } catch(error) {
        console.error(error);
        captureException(error);
    }
}
